// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCXeO6OZez8_J95_DptlEwrCEpuMgrd3R8",
    authDomain: "coco-app.firebaseapp.com",
    databaseURL: "https://coco-app.firebaseio.com",
    projectId: "coco-app",
    storageBucket: "coco-app.appspot.com",
    messagingSenderId: "275429303144",
    appId: "1:275429303144:web:bfe0c8dd5ef9e43d7c6cdd",
    measurementId: "G-EBRCKGGQHS"
  },
  firebaseApiUrl: 'https://europe-west1-coco-app.cloudfunctions.net/',
  apiURL: 'https://api.cocomanager.com/v1/',
  //apiURL: 'https://api.besanfra.com/v1/',
  version: '6.5.0'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
